export const AppConstants = {
  ONLY_EFT_ALLOWED :[ { name: 'Bank Account', filledIn: true }],
             
  ALL_PAYMENT_METHODS : [ { name: 'Bank Account', filledIn: true },
                          { name: 'Credit Card', filledIn: true } ],

  ONLY_DEBIT_CARD_ALLOWED :['debit'],

  ALL_CARD_TYPES : [],

  EFT_LIMIT: 300000,
  
  CARD_LIMIT: 5000,
  
};
